import { PERMISSIONS } from "helpers/roles"

export const adminMenus = [
  {
    name: "Dashboard",
    tab: "/dashboard",
    path: "/dashboard",
    className: "sub-menu",
    icon: "icon-dasboard",
    subTabs: [],
    permission: ["DASHBOARD"],
    menuType: ["INVESTOR", "WEALTH_PARTNER"],
  },
  {
    name: "Wealth Partner",
    tab: "/wealth-partners",
    path: "/#",
    icon: "icon-wealth-partner",
    className: "sub-menu",
    permission: [PERMISSIONS.WEALTH_PARTNER_LIST],
    menuType: ["WEALTH_PARTNER"],
    subTabs: [
      // {
      //   path: "/wealth-partners/invite",
      //   name: "Invite Wealth Partner",
      //   permission: [PERMISSIONS.WEALTH_PARTNER_CREATE],
      // },
      {
        path: "/wealth-partners",
        name: "List",
        permission: [PERMISSIONS.WEALTH_PARTNER_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/wealth-partners/profile-updates",
        name: "Profile Updates",
        permission: [PERMISSIONS.WEALTH_PARTNER_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/wealth-partners/account-deletions",
        name: "Account Deletions",
        permission: [PERMISSIONS.WEALTH_PARTNER_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/wealth-partners/agreements",
        name: "Agreements",
        permission: [PERMISSIONS.WEALTH_PARTNER_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/wealth-partners/signing-docs",
        name: "Signing Requests",
        permission: [PERMISSIONS.WEALTH_PARTNER_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
    ],
  },
  {
    name: "Investors",
    tab: "/investors",
    path: "/#",
    icon: "icon-Investors",
    className: "sub-menu",
    permission: [PERMISSIONS.INVESTOR_LIST],
    menuType: ["INVESTOR"],
    subTabs: [
      {
        path: "/investors",
        name: "List",
        permission: [PERMISSIONS.INVESTOR_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/investors/profile-updates",
        name: "Profile Updates",
        permission: [PERMISSIONS.INVESTOR_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/investors/account-deletions",
        name: "Account Deletions",
        permission: [PERMISSIONS.INVESTOR_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/investors/agreements",
        name: "Agreements",
        permission: [PERMISSIONS.INVESTOR_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
    ],
  },
  {
    name: "Investor Management",
    tab: "/investors",
    path: "/#",
    icon: "icon-Investors",
    className: "sub-menu",
    permission: [PERMISSIONS.INVESTOR_LIST],
    menuType: ["WEALTH_PARTNER"],
    subTabs: [
      {
        name: "Investors",
        className: "sub-menu",
        permission: [PERMISSIONS.INVESTOR_LIST],
        menuType: ["WEALTH_PARTNER"],
        subTabs: [
          {
            path: "/investors",
            name: "List",
            permission: [PERMISSIONS.INVESTOR_LIST],
            menuType: ["WEALTH_PARTNER"],
          },
          // {
          //   path: "/investors/profile-updates",
          //   name: "Profile Updates",
          //   permission: [PERMISSIONS.INVESTOR_LIST],
          //   menuType: ["WEALTH_PARTNER"],
          // },
          // {
          //   path: "/investors/account-deletions",
          //   name: "Account Deletions",
          //   permission: [PERMISSIONS.INVESTOR_LIST],
          //   menuType: ["WEALTH_PARTNER"],
          // },
          // {
          //   path: "/investors/agreements",
          //   name: "Agreements",
          //   permission: [PERMISSIONS.INVESTOR_LIST],
          //   menuType: ["WEALTH_PARTNER"],
          // },
        ],
      },
      {
        name: "Fund Requests",
        className: "sub-menu",
        permission: [PERMISSIONS.INVESTOR_LIST],
        menuType: ["WEALTH_PARTNER"],
        subTabs: [
          {
            path: "/icd",
            name: "Investor Requests",
            permission: [PERMISSIONS.ICD_LIST],
            menuType: ["INVESTOR", "WEALTH_PARTNER"],
          },
          {
            path: "/icd/my-requests",
            name: "My Fund Requests",
            permission: [PERMISSIONS.ICD_LIST],
            menuType: ["INVESTOR", "WEALTH_PARTNER"],
          },
          // {
          //   path: "/icd/signing-docs",
          //   name: "Signing Requests",
          //   permission: [PERMISSIONS.ICD_LIST],
          //   menuType: ["INVESTOR", "WEALTH_PARTNER"],
          // },
          // {
          //   path: "/icd/payments",
          //   name: "Payments",
          //   permission: [PERMISSIONS.ICD_LIST],
          //   menuType: ["INVESTOR", "WEALTH_PARTNER"],
          // },
        ],
      },
    ],
  },
  {
    name: "ICDs",
    tab: "/icd",
    path: "/#",
    icon: "icon-create-icd-request",
    permission: [PERMISSIONS.ICD_LIST],
    className: "sub-menu",
    menuType: ["INVESTOR"],
    subTabs: [
      {
        path: "/icd",
        name: "Investor Requests",
        permission: [PERMISSIONS.ICD_LIST],
        menuType: ["INVESTOR"],
      },
      {
        path: "/icd/my-requests",
        name: "My Fund Requests",
        permission: [PERMISSIONS.ICD_LIST],
        menuType: ["INVESTOR"],
      },
      {
        path: "/icd/signing-docs",
        name: "Signing Requests",
        permission: [PERMISSIONS.ICD_LIST],
        menuType: ["INVESTOR"],
      },
      {
        path: "/icd/payments",
        name: "Payments",
        permission: [PERMISSIONS.ICD_LIST],
        menuType: ["INVESTOR"],
      },
    ],
  },
  {
    name: "Commission & Reports",
    tab: "/reports",
    path: "/#",
    icon: "icon-reports",
    permission: [PERMISSIONS.REPORT_LIST],
    className: "sub-menu",
    menuType: ["WEALTH_PARTNER"],
    subTabs: [
      {
        path: "/reports/commission-report",
        name: "Commission Report",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["WEALTH_PARTNER"],
      },
      {
        path: "/reports/invoice",
        name: "Invoices",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["WEALTH_PARTNER"],
      },
      {
        path: "/reports/generate-financial-reports",
        name: "Generate Financial Reports",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["WEALTH_PARTNER"],
      },
      {
        path: "/reports/tds-years",
        name: "TDS Certificates",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["WEALTH_PARTNER"],
      },
      {
        path: "/reports/soa-years",
        name: "Account Statements",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["WEALTH_PARTNER"],
      },
    ],
  },
  {
    name: "Reports",
    tab: "/reports",
    path: "/#",
    icon: "icon-reports",
    permission: [PERMISSIONS.REPORT_LIST],
    className: "sub-menu",
    menuType: ["INVESTOR"],
    subTabs: [
      {
        path: "/reports/generate-financial-reports",
        name: "Generate Financial Reports",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["INVESTOR"],
      },
      {
        path: "/reports/tds-years",
        name: "TDS Certificates",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["INVESTOR"],
      },
      {
        path: "/reports/soa-years",
        name: "Account Statements",
        permission: [PERMISSIONS.REPORT_CREATE],
        menuType: ["INVESTOR"],
      },
    ],
  },

  {
    name: "Platform Manager",
    tab: "/platform-manager",
    path: "/#",
    icon: "icon-platform-manager",
    className: "sub-menu",
    permission: [PERMISSIONS.PLATFORM_MANAGER_LIST],
    menuType: ["INVESTOR"],
    subTabs: [
      {
        path: "/platform-manager/system-configuration",
        name: "System Configuration",
        permission: [PERMISSIONS.PLATFORM_MANAGER_LIST],
        menuType: ["INVESTOR"],
      },
      {
        path: "/platform-manager/integration-management",
        name: "Integration Management",
        permission: [PERMISSIONS.PLATFORM_MANAGER_LIST],
        menuType: ["INVESTOR"],
      },
      {
        path: "/platform-manager/signers",
        name: "Signatory",
        permission: [PERMISSIONS.PLATFORM_MANAGER_LIST],
        menuType: ["INVESTOR"],
      },
    ],
  },
  {
    name: "Setup",
    isSectionHeading: "title",
    className: "menu-title",
    subTabs: [],
    menuType: ["INVESTOR", "WEALTH_PARTNER"],
    permission: [PERMISSIONS.USER_LIST, PERMISSIONS.ROLE_LIST],
  },
  {
    name: "User Management",
    tab: "/user-management",
    path: "/#",
    className: "sub-menu",
    permission: [PERMISSIONS.USER_LIST, PERMISSIONS.ROLE_LIST],
    icon: "icon-user-management",
    menuType: ["INVESTOR", "WEALTH_PARTNER"],
    subTabs: [
      {
        path: "/user-management/create",
        name: "Create",
        permission: [PERMISSIONS.USER_CREATE, PERMISSIONS.ROLE_CREATE],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
      {
        path: "/user-management",
        name: "List",
        permission: [PERMISSIONS.USER_LIST, PERMISSIONS.ROLE_LIST],
        menuType: ["INVESTOR", "WEALTH_PARTNER"],
      },
    ],
  },
  {
    name: "Manage Resources",
    tab: "/resources",
    path: "#",
    className: "sub-menu",
    permission: [
      "ABOUT_US_LIST",
      "ABOUT_ICD_LIST",
      "BLOG_LIST",
      "FAQ_LIST",
      "VIDEO_LIST",
    ],
    icon: "icon-blogs",
    menuType: ["INVESTOR"],
    subTabs: [
      {
        name: "About ICDs",
        path: "/resources/about-icds",
        permission: ["ABOUT_ICD_LIST"],
        menuType: ["INVESTOR"],
      },
      {
        name: "About Prachay",
        path: "/resources/about-us",
        permission: ["ABOUT_US_LIST"],
        menuType: ["INVESTOR"],
      },
      {
        path: "/resources/blogs",
        name: "Blogs",
        permission: ["BLOG_LIST"],
        menuType: ["INVESTOR"],
      },
      {
        path: "/resources/faqs",
        name: "FAQs",
        permission: ["FAQ_LIST"],
        menuType: ["INVESTOR"],
      },
      {
        path: "/resources/investment-videos",
        name: "Videos",
        permission: ["VIDEO_LIST"],
        menuType: ["INVESTOR"],
      },
      {
        path: "/resources/sample-documents",
        name: "Sample Documents",
        permission: ["DOC_LIST"],
        menuType: ["INVESTOR"],
      },
      {
        path: "/resources/founder-message",
        name: "Founder's Message",
        permission: ["FOUNDER_MESSAGE_LIST"],
        menuType: ["INVESTOR"],
      },
    ],
  },

  {
    name: "Help",
    tab: "/help",
    path: "/help/requests",
    className: "sub-menu",
    permission: ["HELP_LIST"],
    icon: "icon-help",
    subTabs: [],
    menuType: ["INVESTOR", "WEALTH_PARTNER"],
  },
]

export const investorsMenus = [
  {
    name: "Dashboard",
    tab: "/dashboard",
    path: "/dashboard",
    className: "sub-menu",
    icon: "icon-dasboard",
    subTabs: [],
    permission: [],
  },
  {
    name: "Profile",
    tab: "/profile",
    path: "#",
    className: "sub-menu",
    icon: "icon-profile",
    kycCheck: true,
    permission: ["PROFILE_KYC_DETAILS", "PROFILE_EXECUTED_DOCS"],
    subTabs: [
      {
        path: "/profile/kyc-details/company-information",
        name: "Company Information",
        icon: "icon-personal-information",
        permission: ["PROFILE_KYC_DETAILS"],
        entity: ["COMPANY"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/personal-information",
        name: "Personal Information",
        icon: "icon-personal-information",
        permission: ["PROFILE_KYC_DETAILS"],
        entity: ["INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/bank-details",
        name: "Bank Details",
        icon: "icon-bank-details",
        permission: ["PROFILE_KYC_DETAILS"],
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/authorised-signatory",
        name: "Authorised Person",
        icon: "icon-kyc-details",
        entity: ["COMPANY"],
        permission: ["PROFILE_KYC_DETAILS"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/kyc-documents",
        name: "KYC Documents",
        icon: "icon-KYC-documents",
        permission: ["PROFILE_KYC_DETAILS"],
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/documents/icd-agreements",
        name: "Executed Documents",
        icon: "icon-ICD-master-agreement",
        permission: ["PROFILE_EXECUTED_DOCS"],
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/updates",
        name: "Profile Updates",
        icon: "icon-update-profile",
        permission: ["PROFILE_UPDATE"],
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
    ],
  },
  {
    name: "ICD Investments",
    tab: "/icd-investments",
    path: "#",
    className: "sub-menu",
    icon: "icon-investments",
    permission: [
      "VIEW_FUND_REQUIREMENTS",
      "CREATE_FUND_AVAILABILITY",
      "INVESTMENTS_LIST",
      "ICD_PAYMENTS",
      "ICD_SIGNING_REQUESTS",
    ],
    kycCheck: true,
    subTabs: [
      {
        path: "/icd-investments/fund-requests",
        name: "Explore Fund Requirements",
        permission: ["VIEW_FUND_REQUIREMENTS"],
        icon: "icon-fund-request",
        kycCheck: true,
      },
      {
        path: "/icd-investments/create",
        name: "Inform Fund Availability",
        permission: ["CREATE_FUND_AVAILABILITY"],
        icon: "icon-create-icd-request",
        kycCheck: true,
      },
      {
        path: "/icd-investments/my-icds",
        name: "List of Investments",
        permission: ["INVESTMENTS_LIST"],
        icon: "icon-icd-investments",
        kycCheck: true,
      },
      // {
      //   path: "/icd-investments/my-interests",
      //   name: "My Interests",
      //   permission: ["ICD"],
      //   kycCheck: true,
      // },
      {
        path: "/icd-investments/payments",
        name: "Payments",
        permission: ["ICD_PAYMENTS"],
        icon: "icon-payments",
        kycCheck: true,
      },
      {
        path: "/icd-investments/signing-request",
        name: "Signing Requests",
        permission: ["ICD_SIGNING_REQUESTS"],
        icon: "icon-signing-request",
        kycCheck: true,
      },
    ],
  },
  {
    name: "Reports",
    tab: "/reports",
    path: "#",
    className: "sub-menu",
    icon: "icon-reports",
    kycCheck: true,
    permission: ["REPORTS"],
    subTabs: [
      {
        path: "/reports/quarterly-tds",
        name: "TDS Certificates",
        icon: "icon-account-statement",
        permission: ["REPORTS"],
        kycCheck: true,
      },
      {
        path: "/reports/account-statements",
        name: "Account Statements",
        icon: "icon-tds-cerrtificate",
        permission: ["REPORTS"],
        kycCheck: true,
      },
      {
        path: "/reports/investment-schedule",
        name: "Investment Schedules",
        icon: "icon-investment-schedule",
        permission: ["REPORTS"],
        kycCheck: true,
      },
    ],
  },
  {
    name: "Resources",
    tab: "/resources",
    path: "#",
    className: "sub-menu",
    icon: "icon-resources",
    permission: [
      "RESOURCES_ABOUT_ICD",
      "RESOURCES_ABOUT_PRACHAY",
      "RESOURCES_FAQ",
      "RESOURCES_DOCUMENTS",
      "RESOURCES_VIDEOS",
    ],
    subTabs: [
      {
        path: "/resources/about-icd",
        name: "About ICDs",
        permission: ["RESOURCES_ABOUT_ICD"],
        icon: "icon-about-icd",
      },
      {
        path: "/resources/about-prachay",
        name: "About Prachay",
        permission: ["RESOURCES_ABOUT_PRACHAY"],
        icon: "icon-about-prachay",
      },
      {
        path: "/resources/faq",
        name: "FAQs",
        permission: ["RESOURCES_FAQ"],
        icon: "icon-faqs",
      },
      {
        path: "/resources/documents",
        name: "Sample Documents",
        permission: ["RESOURCES_DOCUMENTS"],
        icon: "icon-documents",
      },
      {
        path: "/resources/videos",
        name: "Videos",
        permission: ["RESOURCES_VIDEOS"],
        icon: "icon-video",
      },
    ],
  },
  {
    name: "User Management",
    tab: "/manage-users",
    path: "/#",
    className: "sub-menu",
    permission: ["USERS_LIST"],
    kycCheck: true,
    icon: "icon-user-management",
    subTabs: [
      {
        path: "/manage-users/create",
        name: "Create user",
        permission: ["USERS_CREATE"],
      },
      {
        path: "/manage-users",
        name: "List",
        permission: ["USERS_LIST"],
      },
    ],
  },
  {
    name: "Help",
    tab: "/help",
    path: "/help/requests",
    className: "sub-menu",
    permission: ["HELP"],
    icon: "icon-help",
    subTabs: [],
  },
]

export const wealthPartnerMenus = [
  {
    name: "Dashboard",
    tab: "/dashboard",
    path: "/dashboard",
    className: "sub-menu",
    icon: "icon-dasboard",
    subTabs: [],
    permission: [],
  },
  {
    name: "Profile",
    tab: "/profile",
    path: "#",
    className: "sub-menu",
    icon: "icon-profile",
    kycCheck: true,
    permission: [],
    subTabs: [
      {
        path: "/profile/kyc-details/company-information",
        name: "Entity Information",
        // icon: "icon-personal-information",
        entity: ["COMPANY"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/personal-information",
        name: "Personal Information",
        // icon: "icon-personal-information",
        entity: ["INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/bank-details",
        name: "Bank Details",
        // icon: "icon-bank-details",
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/authorised-signatory",
        name: "Authorised Person",
        // icon: "icon-kyc-details",
        entity: ["COMPANY"],
        kycCheck: true,
      },
      {
        path: "/profile/kyc-details/kyc-documents",
        name: "KYC Documents",
        // icon: "icon-KYC-documents",
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/documents/icd-agreements",
        name: "Executed Documents",
        // icon: "icon-ICD-master-agreement",
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
      {
        path: "/profile/updates",
        name: "Profile Updates",
        // icon: "icon-update-profile",
        entity: ["COMPANY", "INDIVIDUAL"],
        kycCheck: true,
      },
    ],
  },
  {
    name: "Investor Management",
    tab: "/investor-management",
    path: "/investor-management",
    className: "sub-menu",
    icon: "icon-Investors",
    kycCheck: true,
    permission: [],
    subTabs: [
      {
        path: "/investor-management/onboard",
        name: "Onboard Investor",
      },
      {
        path: "/investor-management",
        name: "List",
      },
      {
        path: "/investor-management/agreements",
        name: "Agreements",
      },
    ],
  },
  {
    name: "Investment Management",
    tab: "/investment-management",
    path: "/investment-management",
    className: "sub-menu",
    icon: "icon-create-icd-request",
    kycCheck: true,
    permission: [],
    subTabs: [
      {
        path: "/investment-management/fund-requirements",
        name: "Explore Fund Requirements",
      },
      {
        path: "/investment-management/create",
        name: "Inform Fund Availability",
      },
      {
        path: "/investment-management/fund-requests",
        name: "List of Investments",
      },
      {
        path: "/investment-management/payments",
        name: "Payments",
      },
    ],
  },
  {
    name: "Earnings & Reports",
    tab: "/reports",
    path: "#",
    className: "sub-menu",
    icon: "icon-reports",
    kycCheck: true,
    permission: [],
    subTabs: [
      {
        path: "/reports/commission",
        name: "Commission Report",
        // icon: "icon-account-statement",
      },
      {
        path: "/reports/quarterly-tds",
        name: "TDS Certificates",
        // icon: "icon-account-statement",
      },
      {
        path: "/reports/account-statements",
        name: "Account Statements",
        // icon: "icon-tds-cerrtificate",
      },
      {
        path: "/reports/invoices",
        name: "Invoices",
        // icon: "icon-tds-cerrtificate",
      },
    ],
  },
  {
    name: "Resources",
    tab: "/resources",
    path: "#",
    className: "sub-menu",
    icon: "icon-resources",
    permission: [],
    subTabs: [
      {
        path: "/resources/about-icd",
        name: "About ICDs",
        // icon: "icon-about-icd",
      },
      {
        path: "/resources/about-prachay",
        name: "About Prachay",
        // icon: "icon-about-prachay",
      },
      {
        path: "/resources/faq",
        name: "FAQs",
        // icon: "icon-faqs",
      },
      {
        path: "/resources/documents",
        name: "Sample Documents",
        // icon: "icon-documents",
      },
      {
        path: "/resources/videos",
        name: "Videos",
        // icon: "icon-video",
      },
    ],
  },
  {
    name: "Help",
    tab: "/help",
    path: "/help/requests",
    className: "sub-menu",
    permission: [],
    icon: "icon-help",
    subTabs: [],
  },
]
